import React, { useState, useEffect } from "react";
import './CoordinatorAccordion.css';
import { FiTrash2 } from "react-icons/fi";
import { LuPlus } from "react-icons/lu";
import { FiPlusCircle } from "react-icons/fi";
import { FaEnvelopeOpenText } from "react-icons/fa";
import { Link } from "react-router-dom";
import { FaRegTrashCan } from "react-icons/fa6";
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import Swal from "sweetalert2";
import withReactContent from 'sweetalert2-react-content';
import InviteAuthorModal from "../InviteAuthorModal/InviteAuthorModal";
import axios from "axios";

export default function CoordinatorAccordion({ eventName, dateRange, onAuthorMissingChange }) {

  const navigate = useNavigate();
  const MySwal = withReactContent(Swal);
  const [coordinatorEmail, setCoordinatorEmail] = useState("");
  const [inviteSent, setInviteSent] = useState(false);

  const handleClick = () => {
    navigate('/EditAddEventPage');
  };

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  const [authorName, setAuthorName] = useState("");
  const [authorEmail, setAuthorEmail] = useState("");

  useEffect(() => {
    const email = localStorage.getItem("coordinatorEmail"); // adjust key if needed
    if (email) setCoordinatorEmail(email);
  }, []);

  //const [openIndex, setOpenIndex] = useState(null);
  const [openIndex, setOpenIndex] = useState(0);
  const [accordionData, setAccordionData] = useState([
    {
      authorName: '',
      authorISBN: '',
      authorEmail: '',
      authorData: null,
      authorBookData: [],
      loading: false,
      error: null,
      loading1: false,
      error1: null,
      authorDataAdded: null,
      authorBookDataAdded: [],
      showInviteForm: false,
    },
  ]);
  useEffect(() => {
    if (onAuthorMissingChange) {
      // If any accordion has showInviteForm true, it means author not found
      const anyMissing = accordionData.some(acc => acc.showInviteForm);
      onAuthorMissingChange(anyMissing);
    }
  }, [accordionData, onAuthorMissingChange]);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    if (accordionData) {
      localStorage.setItem('authorsBooksdata', JSON.stringify(accordionData));
    }
  }, [accordionData]);

  const sendinvite1 = async () => {
    // console.log('Kamal email');
    if (!authorEmail) {
      alert("Please enter an email address");
      return;
    }

    const coordinatorId = localStorage.getItem('cordinator_id');

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/send_invite.php?authorEmail=${authorEmail}&authorName=${authorName}&coordinator_id=${coordinatorId}`);
      if (!response.ok) {
        throw new Error('Something went wrong');
      }
      const data = await response.json();
      if (data.success) {
        Swal.fire({
          title: "Mail Sent Successfully!",
          text: "The invitation email was sent successfully.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          title: "Mail Sending Failed!",
          text: data.message || "There was an issue sending the invitation. Please try again.",
          icon: "error",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      alert("An error occurred while sending the invite.");
    } finally {
      // do nothing
    }

  };

  const handleNext = () => {
    // console.log("validation ggh");
    if (!eventName || !dateRange || !dateRange[0] || !dateRange[1]) {
      alert("Please enter event name and date range first.");
      return;
    }

    // Save data before navigating
    localStorage.setItem("eventName", eventName);
    localStorage.setItem("eventDate", JSON.stringify(dateRange));

    navigate("/edit-event");
  };

  const handleInputChange = (index, event) => {
    const updatedData = [...accordionData];
    updatedData[index].authorName = event.target.value;
    setAccordionData(updatedData);
  };

  const handleInputISBNChange = (index, event) => {
    const updatedData = [...accordionData];
    updatedData[index].authorISBN = event.target.value;
    setAccordionData(updatedData);
  };

  const fetchAuthorData = async (index) => {
    const updatedData = [...accordionData];
    const authorName = updatedData[index].authorName;

    if (!authorName) return;

    // Reset previous error & data
    updatedData[index].error = null;
    updatedData[index].error1 = null;
    updatedData[index].authorData = null;
    updatedData[index].loading = true;
    updatedData[index].loading1 = true;
    updatedData[index].showInviteForm = false;
    setAccordionData([...updatedData]);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_author_data_event.php?author_name=${encodeURIComponent(authorName)}`);

      const data = await response.json();

      if (data.success && data.users && data.users.length > 0) {
        updatedData[index].authorData = data.users[0];
        updatedData[index].showInviteForm = false;
      } else {
        updatedData[index].error = "Author not found.";
        updatedData[index].showInviteForm = true;
      }
    } catch (error) {
      updatedData[index].error = "Something went wrong. Please try again.";
      updatedData[index].showInviteForm = true;
    } finally {
      updatedData[index].loading = false;
      setAccordionData([...updatedData]);
    }
  };

  const fetchAuthorBookData = async (index) => {
    const updatedData = [...accordionData];
    const authorISBN = updatedData[index].authorISBN;

    if (!authorISBN) return;

    updatedData[index].loading1 = true;
    updatedData[index].error1 = null;
    setAccordionData([...updatedData]);

    try {
      let url = `${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_author_data_event.php?isbn=${authorISBN}`;

      // Find author_id from authorBookDataAdded if already added
      let existingAuthor = updatedData[index].authorBookDataAdded.find(author =>
        author.books.some(book => book.isbn === authorISBN)
      );

      if (!existingAuthor && updatedData[index].authorDataAdded) {
        // fallback to authorDataAdded if no existingAuthor found
        existingAuthor = {
          author_id: updatedData[index].authorDataAdded.author_id
        };
      }

      if (existingAuthor?.author_id) {
        url += `&author_id=${existingAuthor.author_id}`;
      }

      const response = await fetch(url);
      const data = await response.json();

      if (data.success && data.users && data.users.length > 0) {
        updatedData[index].authorBookData = data.users;

        // AUTO ADD AUTHOR IF NOT MANUALLY ADDED
        if (!updatedData[index].authorDataAdded) {
          const firstBook = data.users[0];

          // CHECK DUPLICATE BEFORE AUTO ADD
          if (isAuthorAlreadyAdded(firstBook.author_id, index)) {
            Swal.fire({
              icon: "warning",
              title: "Author already added",
              text: "This author is already added in another section.",
            });

            updatedData[index].authorBookData = [];
            updatedData[index].loading1 = false;
            setAccordionData([...updatedData]);
            return;
          }

          updatedData[index].authorDataAdded = {
            authorName: firstBook.profile_name,
            author_id: firstBook.author_id
          };

          updatedData[index].authorBookDataAdded = [
            {
              author_id: firstBook.author_id,
              author_name: firstBook.profile_name,
              books: []
            }
          ];

          updatedData[index].authorData = {
            author_id: firstBook.author_id,
            profile_name: firstBook.profile_name
          };
        }

      } else {
        updatedData[index].error1 = "ISBN not found or not associate with this author.";
        updatedData[index].authorBookData = [];
      }

    } catch (error) {
      updatedData[index].error1 = error.message;
      updatedData[index].authorBookData = [];
    } finally {
      updatedData[index].loading1 = false;
      setAccordionData([...updatedData]);
    }
  };

  const isAuthorAlreadyAdded = (authorId, currentIndex) => {
    return accordionData.some((acc, i) => {
      return (
        i !== currentIndex &&
        acc.authorDataAdded &&
        acc.authorDataAdded.author_id === authorId
      );
    });
  };

  const addAuthor = (index, authorData) => {
    const authorId = authorData.author_id;

    if (isAuthorAlreadyAdded(authorId, index)) {
      Swal.fire({
        icon: "warning",
        title: "Author already added",
        text: "This author is already added in another section.",
      });
      return;
    }

    const updatedData = [...accordionData];

    updatedData[index].authorEmail = authorData.email_id;
    updatedData[index].authorDataAdded = {
      authorName: authorData.profile_name,
      author_id: authorId,
    };

    updatedData[index].authorBookDataAdded = [];

    updatedData[index].authorData = null;

    setAccordionData(updatedData);
  };


  const addAuthorBook = (index, authorBookData) => {
    const updatedData = [...accordionData];

    // Check if author already exists
    const existingAuthorIndex = updatedData[index].authorBookDataAdded.findIndex(
      (author) => author.author_id === authorBookData.author_id
    );

    if (existingAuthorIndex >= 0) {
      const author = updatedData[index].authorBookDataAdded[existingAuthorIndex];

      // Check if the book already exists by ISBN
      const bookExists = author.books.some(
        (book) => book.isbn === authorBookData.isbn
      );

      if (!bookExists) {
        // If not duplicate, add the book
        author.books.push({
          title: authorBookData.title,
          price: authorBookData.price,
          isbn: authorBookData.isbn,
        });
      } else {
        console.log("Book already exists for this author.");
      }
    } else {
      // Author doesn't exist, add author and their book
      updatedData[index].authorBookDataAdded.push({
        author_id: authorBookData.author_id,
        author_name: authorBookData.profile_name,
        books: [
          {
            title: authorBookData.title,
            price: authorBookData.price,
            isbn: authorBookData.isbn,
          },
        ],
      });
    }
    updatedData[index].authorISBN = "";
    updatedData[index].authorBookData = [];
    // console.log(updatedData[index], 'authorBookDataAdded');
    setAccordionData(updatedData);
  };

  const handleDelete = (authorIndex, bookIndex) => {
    // Copy the top-level accordion data
    const updatedData = [...accordionData];

    // Make sure authorBookDataAdded exists
    const updatedAuthorBookDataAdded = [...updatedData[authorIndex].authorBookDataAdded];
    // console.log(updatedAuthorBookDataAdded,'updateauthor bookdataadded');
    // Safety check: make sure the author exists at that index
    if (!updatedAuthorBookDataAdded[0]) {
      // console.error("Author index invalid:", authorIndex);
      return;
    }

    // Clone the books array of the specific author
    const updatedBooks = [...updatedAuthorBookDataAdded[0].books];

    // Safety check: make sure book index exists
    if (!updatedBooks[bookIndex]) {
      // console.error("Book index invalid:", bookIndex);
      return;
    }

    // Remove the book
    updatedBooks.splice(bookIndex, 1);

    // Set the updated books back
    updatedAuthorBookDataAdded[0].books = updatedBooks;

    // Set the updated authorBookDataAdded back into accordionData
    updatedData[authorIndex].authorBookDataAdded = updatedAuthorBookDataAdded;

    // Update state
    setAccordionData(updatedData);
  };

  const addAccordion = () => {
    setAccordionData(prev => {
      const newAccordion = {
        authorName: '',
        authorISBN: '',
        authorEmail: '',
        authorData: null,
        authorBookData: [],
        loading: false,
        error: null,
        error1: null,
        authorDataAdded: null,
        authorBookDataAdded: [],
        showInviteForm: false,
      };

      const newData = [...prev, newAccordion];

      // close previous & open newly added accordion
      setOpenIndex(newData.length - 1);

      return newData;
    });
  };

  const handleDeleteAccordion = (indexToDelete) => {
    setAccordionData(prevData => {
      const newData = prevData.filter((_, i) => i !== indexToDelete);

      // Determine which accordion should open next
      if (newData.length === 0) {
        setOpenIndex(null);
      } else if (indexToDelete === 0) {
        // If first one deleted → open new first
        setOpenIndex(0);
      } else {
        // Open previous accordion
        setOpenIndex(indexToDelete - 1);
      }

      return newData;
    });
  };

  const saveEventDraft = async () => {
    const cordinator_id = localStorage.getItem("cordinator_id");
    const eventDetail = localStorage.getItem("eventDetail");
    const eventLocation = localStorage.getItem("eventLocation");
    const eventNotes = localStorage.getItem("eventNotes");
    const eventStartTime = localStorage.getItem("eventStarttime");
    const eventEndTime = localStorage.getItem("eventEndtime");

    if (!eventName || !dateRange || !dateRange[0] || !dateRange[1]) {
      alert("Please enter event name and date range first.");
      return;
    }

    const postData = {
      bookDataArray: accordionData,   // ✅ correct variable
      cordinator_id,
      eventName,
      formattedStartDate: dateRange[0],  // ✅ use dateRange
      formattedEndDate: dateRange[1],
      eventDetail,
      eventLocation,
      eventNotes,
      event_start_time: eventStartTime,
      event_end_time: eventEndTime,
      event_status: "draft"
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}authormeetapi/save_event_data.php`,
        postData,
        { headers: { "Content-Type": "application/json" } }
      );

      if (response.data.status === "success") {
        Swal.fire({
          title: "Draft Saved!",
          text: "You can edit this event anytime.",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          navigate("/coordinator-dashboard");
        });
      }
    } catch (error) {
      alert("Failed to save draft.");
    }
  };


  // Send Invite popup
  const sendinvite = async () => {
    const { value: formData } = await MySwal.fire({
      title: '',
      html: (
        <div className='mainsendinvitemodal'>
          <div className='container'>
            <div className="row mb-2">
              <div className="col-lg-2">
                <div className="sendpoplable d-flex justify-content-start align-items-center h-100">
                  <p>To:</p>
                </div>
              </div>
              <div className="col-lg-10">
                <input type="text" className="sendpopInput form-control rounded-0" placeholder="Author email address" />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-lg-2">
                <div className="sendpoplable d-flex justify-content-start align-items-center h-100">
                  <p>From:</p>
                </div>
              </div>
              <div className="col-lg-10">
                <input type="text" className="sendpopInput form-control rounded-0" value={coordinatorEmail} placeholder="Your email address" />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-lg-2">
                <div className="sendpoplable d-flex justify-content-start align-items-center h-100">
                  <p>Subject:</p>
                </div>
              </div>
              <div className="col-lg-10">
                <input type="text" className="sendpopInputone form-control rounded-0" placeholder="You’ve Been Invited to Sign Up for AuthorMeet!" />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-lg-2">
                <div className="sendpoplable text-start">
                  <p>Message:</p>
                </div>
              </div>
              <div className="col-lg-10">
                <textarea class="form-control sendpopInputtextarea" rows="12"></textarea>
              </div>
            </div>
          </div>
        </div>
      ),
      showCancelButton: false,
      showCloseButton: true,
      confirmButtonText: 'SEND',
      focusConfirm: false,
      customClass: {
        popup: `mymainpopupsend`,
        confirmButton: `mysendbutton`,
        actions: `mysendbox`,
      },
    });
  };

  return (
    <>
      {isMobile ? (
        <div className="coordinatoraccordionmobil">
          <div className="row">
            <div className="col-lg-12">
              <div className="addeventmobilAccordion accordion" id="mobilecoordinatorAccordion">
                {accordionData.map((accordion, index) => (
                  <div className="addeventmobilMainitem accordion-item" key={index}>
                    <h2 className="accordion-header">
                      <button className={`addeventmobilbuttonItem addeventBeforebg accordion-button ${openIndex === index ? '' : `addeventbgColor collapsed`}`}
                        type="button" onClick={() => handleToggle(index)} aria-expanded={openIndex === index ? 'true' : 'false'}
                        aria-controls="mobilecoordinatorOne">
                        Author {index + 1}
                      </button>
                    </h2>
                    <div id="mobilecoordinatorOne" className={`accordion-collapse collapse ${openIndex === index ? 'show' : ''}`} data-bs-parent="#mobilecoordinatorAccordion">
                      <div className="accordion-body mobilcoordintorBody">
                        <div className="row">
                          <div className="col-lg-9">
                            <div className="addeventMobilauthorAdded d-flex">
                              <input type="text" className="addeventMobiltypeInput form-control rounded-0" value={accordion.authorName} onChange={(e) => handleInputChange(index, e)} placeholder="Search for author name" />
                              <button className="addeventMobiltypeInputBtn btn btn-danger rounded-0" style={{ width: '30%' }} onClick={() => fetchAuthorData(index)}>
                                Search
                              </button>
                            </div>
                            {accordion.error && (<p className="addeventError">{accordion.error}</p>)}
                            {accordion.authorData && (
                              <div className="addeventmobilfindBoxResults">
                                <div className="table-responsive">
                                  <table className="addeventMobilresultTable table table-borderless">
                                    <thead>
                                      <tr>
                                        <th className="w-50 text-start">Name/Email</th>
                                        <th className="w-25 text-center">Registered</th>
                                        <th className="w-25 text-center">Add</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td className="w-25 text-start">
                                          {accordion.authorData.profile_name}
                                          <br />
                                          {accordion.authorData.email_id}
                                        </td>
                                        <td className="w-25 text-center">
                                          <div className="addeventgreenDot"></div>
                                        </td>
                                        <td className="w-25 text-center">
                                          <button className="addeventplusButton btn btn-primary" onClick={() => addAuthor(index, accordion.authorData)}>
                                            <LuPlus className="addeventplusIcon" />
                                          </button>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            )}
                            {accordion.authorDataAdded && (
                              <div className="row">
                                <div className="col-xl-12">
                                  <div className="addeventauthoraddBox">
                                    <div className="addeventTitlemain">Author Added</div>
                                    <span className="addeventDatamain">{accordion.authorDataAdded.authorName}</span>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="row mt-4">
                              <div className="col-lg-12">
                                <h3 className="addeventbookTitle">Add Author Books</h3>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-lg-12">
                                <div className="addeventMobilauthorAdded d-flex">
                                  <input type="text" className="addeventMobiltypeInput form-control rounded-0" value={accordion.authorISBN} onChange={(e) => handleInputISBNChange(index, e)} placeholder="Enter Author ISBN" />
                                  <button className="addeventMobiltypeInputBtn btn btn-danger rounded-0" style={{ width: '30%' }} onClick={() => fetchAuthorBookData(index)}>
                                    Search
                                  </button>
                                </div>
                                {accordion.error && <p className="addeventError">{accordion.error}</p>}
                                {accordion.authorBookData && (
                                  <div className="addeventfindBoxResults">
                                    <div className="table-responsive">
                                      <table className="addeventresultTable table table-borderless">
                                        <thead>
                                          <tr>
                                            <th className="w-25 text-start">Title</th>
                                            <th className="text-center">Author</th>
                                            <th className="text-center">ISBN</th>
                                            <th className="text-center">Price</th>
                                            <th className="text-center">Add</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {accordion.authorBookData.map((book) => (
                                            <tr key={book.isbn}>
                                              <td className="w-25 text-start">{book.title}</td>
                                              <td className="text-center">{book.profile_name}</td>
                                              <td className="text-center">{book.isbn}</td>
                                              <td className="text-center">${book.price}</td>
                                              <td className="text-center">
                                                <button className="addeventplusButton btn btn-primary" onClick={() => addAuthorBook(index, book)}>
                                                  <LuPlus className="addeventplusIcon" />
                                                </button>
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-3">
                            <div className="text-end">
                              <button className="accordionDeletebtn btn btn-danger" onClick={() => handleDeleteAccordion(index)}>
                                <FaRegTrashCan className="accordionDeletebtnicon" /> Delete
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-lg-12">
                            <div className="table-responsive">
                              <table className="addeventauthortable table table-bordered">
                                <thead>
                                  <tr>
                                    <th>Author</th>
                                    <th>Title</th>
                                    <th>ISBN</th>
                                    <th>Price</th>
                                    <th className="text-center">Delete</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {accordion.authorBookDataAdded.map((data, authorIndex) => (
                                    data.books.map((book, bookIndex) => (
                                      <tr key={`${authorIndex}-${bookIndex}`}>
                                        <td>{data.author_name}</td>
                                        <td>{book.title}</td>
                                        <td>{book.isbn}</td>
                                        <td>${book.price}</td>
                                        <td className="text-center" onClick={() => handleDelete(authorIndex, bookIndex)}>
                                          <FiTrash2 className="aeatIcon" />
                                        </td>
                                      </tr>
                                    ))
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className='row g-2 mb-4'>
            <div className="col-6">
              <button className='btn btn-success w-100 addanothermobilButton' onClick={addAccordion}>Add Another Author</button>
            </div>
            <div className="col-6">
              <button className='btn btn-primary w-100 addmobilNextButton' onClick={handleClick}>Next</button>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="coordinatoraccordionpage">
            <div className="row">
              <div className="col-lg-12">
                <div className="addeventAccordion accordion" id="eventInfo">
                  {accordionData.map((accordion, index) => (
                    <div className="addeventMainitem accordion-item" key={index}>
                      <h2 className="accordion-header">
                        <button className={`addeventbuttonItem addeventBeforebg accordion-button ${openIndex === index ? '' : `addeventbgColor collapsed`}`}
                          type="button" onClick={() => handleToggle(index)} aria-expanded={openIndex === index ? 'true' : 'false'}
                          aria-controls="collapseOne">
                          Author {index + 1}
                        </button>
                      </h2>
                      <div id="collapseOne" className={`accordion-collapse collapse ${openIndex === index ? 'show' : ''}`} data-bs-parent="#eventInfo">
                        <div className="accordion-body">
                          <div className="row">
                            <div className="col-lg-9">
                              <div className="addeventauthorAdded d-flex">
                                <input type="text" className="addeventtypeInput form-control rounded-0 me-2" value={accordion.authorName} onChange={(e) => handleInputChange(index, e)} placeholder="Enter Author Name" />
                                <button className="addeventtypeInputBtn btn btn-danger rounded-0" style={{ width: '30%' }} onClick={() => fetchAuthorData(index)}>
                                  Search
                                </button>
                              </div>
                              {/*{accordion.error && <p className="addeventError">{accordion.error}</p>} */}
                              {accordion.authorData && (
                                <div className="addeventfindBoxResults">
                                  <div className="table-responsive">
                                    <table className="addeventresultTable table table-borderless">
                                      <thead>
                                        <tr>
                                          <th className="w-25 text-start">Name</th>
                                          <th className="w-25 text-center">Registered</th>
                                          <th className="w-25 text-center">Email</th>
                                          <th className="w-25 text-center">Save To List</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td className="w-25 text-start">{accordion.authorData.profile_name}</td>
                                          <td className="w-25 text-center">
                                            <div className="addeventgreenDot"></div>
                                          </td>
                                          <td className="w-25 text-center">{accordion.authorData.email_id}</td>
                                          <td className="w-25 text-center">
                                            <button className="addeventplusButton btn btn-primary" onClick={() => addAuthor(index, accordion.authorData)}>
                                              <LuPlus className="addeventplusIcon" />
                                            </button>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              )}
                              {accordion.authorDataAdded && (
                                <div className="row">
                                  <div className="col-xl-12">
                                    <div className="addeventauthoraddBox">
                                      <div className="addeventTitlemain">Author Added</div>
                                      <span className="addeventDatamain">{accordion.authorDataAdded.authorName}</span>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="col-lg-2">
                              <div className="text-end">
                                <button className="accordionDeletebtn btn btn-danger" onClick={() => handleDeleteAccordion(index)}>
                                  <FaRegTrashCan className="accordionDeletebtnicon" /> Delete
                                </button>
                              </div>
                            </div>
                          </div>

                          {accordion.showInviteForm && !inviteSent && (
                            <>
                              <div className="row mt-2">
                                <div className="col-lg-12">
                                  <h3 className="addeventbookTitle">Send author invite to register</h3>
                                </div>
                              </div>

                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="row g-2">
                                    <div className="col-lg-3">
                                      <input type="text" className="addeventtypeInput form-control rounded-0" placeholder="Author Name" value={authorName}
                                        onChange={(e) => setAuthorName(e.target.value)} />
                                    </div>
                                    <div className="col-lg-6">
                                      <input type="email" className="addeventtypeInput form-control rounded-0" placeholder="Author email address" value={authorEmail}
                                        onChange={(e) => setAuthorEmail(e.target.value)} />
                                    </div>
                                    <div className="col-lg-2">
                                      {/*<button className="addeventtypeInputBtn btn btn-danger rounded-0" onClick={sendinvite1} style={{ width: '100%', height: '100%' }}>*/}
                                      <button className="addeventtypeInputBtn btn btn-danger rounded-0 text-nowrap" data-bs-toggle="modal" data-bs-target="#inviteModal"
                                        disabled={!authorName || !authorEmail} style={{ height: '100%' }}>
                                        <FaEnvelopeOpenText className="me-1" /> Send Invite
                                      </button>
                                      <InviteAuthorModal authorEmail={authorEmail} authorName={authorName} cordinatorEmail={coordinatorEmail} onSuccess={() => setInviteSent(true)} onAuthorMissingChange={onAuthorMissingChange} />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-2"></div>
                              </div>
                            </>
                          )}



                          <div className="row mt-4">
                            <div className="col-lg-10">
                              <div className="row">
                                <div className="col-lg-12">
                                  <h3 className="addeventbookTitle">Add Author Books</h3>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="addeventauthorAdded d-flex">
                                    <input type="text" className="addeventtypeInput form-control rounded-0 me-2" value={accordion.authorISBN} onChange={(e) => handleInputISBNChange(index, e)} placeholder="Enter ISBN" />
                                    <button className="addeventtypeInputBtn btn btn-danger rounded-0" style={{ width: '30%' }} onClick={() => fetchAuthorBookData(index)}>
                                      Search
                                    </button>
                                  </div>
                                  {accordion.error1 && <p className="addeventError">{accordion.error1}</p>}
                                  {accordion.authorBookData.length > 0 && (
                                    <div className="addeventfindBoxResults">
                                      <div className="table-responsive">
                                        <table className="addeventresultTable table table-borderless">
                                          <thead>
                                            <tr>
                                              <th className="w-25 text-start">Title</th>
                                              <th className="text-center">Author</th>
                                              <th className="text-center">ISBN</th>
                                              <th className="text-center">Price</th>
                                              <th className="text-center">Save To List</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {accordion.authorBookData.map((book, bkindex) => (
                                              <tr key={book.isbn}>
                                                <td className="w-25 text-start">{book.title}</td>
                                                <td className="text-center">{book.profile_name}</td>
                                                <td className="text-center">{book.isbn}</td>
                                                <td className="text-center">${book.price}</td>
                                                <td className="text-center">
                                                  <button className="addeventplusButton btn btn-primary" onClick={() => addAuthorBook(index, book)}>
                                                    <LuPlus className="addeventplusIcon" />
                                                  </button>
                                                </td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-2"> </div>
                          </div>

                          <div className="row mt-3">
                            <div className="col-lg-12">
                              <div className="table-responsive">
                                <table className="addeventauthortable table table-bordered">
                                  <thead>
                                    <tr>
                                      <th>Author</th>
                                      <th>Title</th>
                                      <th>ISBN</th>
                                      <th>Price</th>
                                      <th className="text-center">Delete</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {accordion.authorBookDataAdded.map((data, authorIndex) => (
                                      data.books.map((book, bookIndex) => (
                                        <tr key={`${authorIndex}-${bookIndex}`}>
                                          <td>{data.author_name}</td>
                                          <td>{book.title}</td>
                                          <td>{book.isbn}</td>
                                          <td>${book.price}</td>
                                          <td className="text-center" onClick={() => handleDelete(authorIndex, bookIndex)}>
                                            <FiTrash2 className="aeatIcon" />
                                          </td>
                                        </tr>
                                      ))
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="addanotherauthorNew">
                <button className="addanotherauthorButton btn btn-success" onClick={addAccordion}>
                  <FiPlusCircle className="addanotherauthorbtnIcon me-1" /> Add another author
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="text-end mt-4 mb-4">

                <button className="addeventnextButtonmain btn btn-primary me-4" onClick={handleNext}  > Next </button>
                <button className="addeventnextButtonmain btn btn-primary" onClick={saveEventDraft}> Save/Edit </button>

              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
